
import { RadioChannelType } from "../../radio/data/RadioChannel";
import { APIAdresses } from "../api/APIAdress";
import { APICall } from "../api/APICall";
import { RadioInfoInput } from "../input/RadioInfoInput";
import { SongInput } from "../input/SongInput";
import { RadioInfoResponse } from "../response/RadioInfoResponse";
import { PHPResponse } from "../../../../library-js/php/PHPResponse";
import { SongResponse } from "../response/SongResponse";

export class SongRequest extends APICall<SongInput,SongResponse>
{
  static readonly ADRESS = APIAdresses.SONG;

  constructor(){ super( SongRequest.ADRESS ); }
  
}